import ttb from "../assets/TTB.jpeg";

export const BANK_PROVIDERS = Object.freeze([
  Object.freeze({
    logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FSCB.png?alt=media&token=4bcea6cf-b654-47ce-a099-7ec62c95169f",
    name: "ธนาคารไทยพาณิชย์",
    shortname: "SCB",
  }),
  Object.freeze({
    logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKBNK.png?alt=media&token=9a4c15d8-ef3c-43a4-bc4e-0498b1a7fa1d",
    name: "ธนาคารกสิกรไทย",
    shortname: "KBNK",
  }),
  Object.freeze({
    logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKTBA.png?alt=media&token=f48498e0-331e-484e-98a2-99880d10cb06",
    name: "ธนาคารกรุงไทย",
    shortname: "KTB",
  }),
  Object.freeze({
    logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBBLA.png?alt=media&token=f563a3e0-fcdc-4135-ac8e-878fa44eeaef",
    name: "ธนาคารกรุงเทพ",
    shortname: "BBL",
  }),
  Object.freeze({
    logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBAYA.png?alt=media&token=e3c78d16-0c04-47ae-9280-867aaef46feb",
    name: "ธนาคารกรุงศรีอยุธยา",
    shortname: "BAY",
  }),
  Object.freeze({
    logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FGSBA.png?alt=media&token=c0d650ae-6748-445d-bc4f-ce8843b9706c",
    name: "ธนาคารออมสิน",
    shortname: "GSBA",
  }),
  Object.freeze({
    logo: ttb,
    name: "ธนาคารทีเอ็มบีธนชาต",
    shortname: "TMB",
  }),
  Object.freeze({
    logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FKKBA.png?alt=media&token=ac103755-a94a-40d4-afef-2383dcb73e89",
    name: "ธนาคารเกียรตินาคิน",
    shortname: "KKBA",
  }),
  Object.freeze({
    logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FGHBA.png?alt=media&token=4caa517e-2d35-4413-8be9-ddfb09ff88b7",
    name: "ธนาคารอาคารสงเคราะห์",
    shortname: "GHBA",
  }),
  Object.freeze({
    logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FBAAC.png?alt=media&token=db135e19-2125-43bb-a4aa-a70b0977f744",
    name: "ธนาคารเพื่อการเกษตรและสหกรณ์",
    shortname: "BAAC",
  }),
  Object.freeze({
    logo: "https://firebasestorage.googleapis.com/v0/b/money-transaction-demo.appspot.com/o/BankProvider%2FUOBT.png?alt=media&token=522b8d11-670c-47f4-b431-e9f199ef1900",
    name: "ยูโอบี",
    shortname: "UOBT",
  }),
]);

export const BANK_ACCOUNT_MAX_LENGTH = 15;

export function bankAccountMaxLength(shortname) {
  if (shortname === "KKBA") return 14;
  if (shortname === "GSBA") return BANK_ACCOUNT_MAX_LENGTH;
  if (shortname === "BAAC") return 13;
  return 10;
}

export function bankAccountRule(value, select) {
  const pattern = /^\d+$/;
  return (
    (pattern.test(value) &&
      value.length <= bankAccountMaxLength(select && select.shortname)) ||
    "กรุณากรอก เลขบัญชี ให้ถูกต้อง"
  );
}
